import { motion } from "framer-motion";
import { LOGO_EMBLEM } from "@/data/albums";

export default function ComingSoon({ chapter, title, blurb, testId }) {
  return (
    <div data-testid={testId} className="relative min-h-screen flex items-center justify-center overflow-hidden px-6">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 60, ease: "linear" }}
        className="absolute pointer-events-none"
      >
        <img src={LOGO_EMBLEM} alt="" className="w-[70vw] max-w-[700px] opacity-[0.06]" style={{ filter: "invert(1) brightness(1.15) contrast(2.6)", mixBlendMode: "screen" }} />
      </motion.div>

      <div className="relative z-10 text-center">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="font-mono text-[11px] uppercase tracking-[0.5em] text-[#8a8a8a] mb-8"
        >
          {chapter}
        </motion.p>
        <h1 className="font-serif font-light tracking-tight text-[#f2f0ec] text-6xl md:text-[9rem] leading-[0.85] overflow-hidden">
          <motion.span className="block" initial={{ y: "110%" }} animate={{ y: "0%" }} transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}>
            {title}
          </motion.span>
        </h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.8 }}
          className="mt-10 font-mono text-xs uppercase tracking-[0.35em] text-[#8a8a8a]"
        >
          Not yet open
        </motion.p>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.8 }}
          className="mt-6 max-w-md mx-auto font-serif italic text-xl text-[#d8d5ce] leading-relaxed"
        >
          {blurb}
        </motion.p>
      </div>
    </div>
  );
}
